import { defineComponent as _defineComponent } from 'vue'
import { ModalWrapper } from '@/shared/ui/modals'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getDateRangeFormatted, getTimeRangeFormatted } from '@/services/date'
import { EventDB } from '@/enitites/event'
import { computed, onMounted, ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import { fetchOrganization } from '@/enitites/organization'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventTicket',
  props: {
    isShowModal: { type: Boolean },
    event: null
  },
  emits: ["update:isShowModal"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:isShowModal', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isShowModal: boolean
  event: EventDB
};

const { getImageById } = useImage()




const organization = ref()

async function getOrganization() {
  organization.value = await fetchOrganization(props.event.orgId)
}

const date = computed(() => getDateRangeFormatted(props.event.dateStart, props.event.dateEnd))
const time = computed(() => getTimeRangeFormatted(props.event.dateStart, props.event.dateEnd))
onMounted(() => {
  getOrganization()
})

return { __sfc: true,getImageById, props, emit, organization, getOrganization, date, time, ModalWrapper }
}

})